import { useMonth } from '@datepicker-react/hooks'
import { format, Locale } from 'date-fns'
import { ReactElement } from 'react'

import { Text } from '../../../Text'
import { useDatePickerContext } from '../../contexts/datePickerContext'
import { DayWrapperRender } from '../../types/dayWrapperRender'
import { Day } from '../Day'
import { MonthHeaderActions } from './elements/MonthHeaderActions'
import * as Styled from './styles'

interface MonthProps {
  dayWrapperRender?: DayWrapperRender
  locale: Locale
  month: number
  year: number
}

export const Month = ({ dayWrapperRender, locale, month, year }: MonthProps): ReactElement => {
  const { firstDayOfWeek } = useDatePickerContext()

  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
    weekdayLabelFormat: (date: Date) => format(date, 'EEEEEE', { locale }),
    monthLabelFormat: (date: Date) => format(date, 'MMMM', { locale }),
  })

  return (
    <Styled.MonthWrapper>
      <MonthHeaderActions month={month} monthLabel={monthLabel} year={year} />

      <Styled.WeekdaysList>
        {weekdayLabels.map((dayLabel) => (
          <Styled.Weekday key={dayLabel}>
            <Text alignment="center" colorVariant="secondary" variant="bodySM">
              {dayLabel}
            </Text>
          </Styled.Weekday>
        ))}
      </Styled.WeekdaysList>

      <Styled.DaysList>
        {days.map((day, index) => {
          if (typeof day === 'object') {
            return (
              <Day
                date={day.date}
                dayLabel={day.dayLabel}
                dayWrapperRender={dayWrapperRender}
                key={day.date.toString()}
              />
            )
          }

          return <div key={index} />
        })}
      </Styled.DaysList>
    </Styled.MonthWrapper>
  )
}
